/* eslint-disable */
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import styled from 'styled-components';
import Button from "components/Button";
import Svg from "_assets/svg";
import MenuWrapper from "./MenuWrapper";
import Wrapper from "./Wrapper";
import ButtonMenu from "./ButtonMenu";
import ButtonUser from "./ButtonUser";
// import ButtonHelp from "./ButtonHelp";

export const Img = styled.img`
width:40px;
`;

const ButtonCustom = styled.button`
  display: inline-block;
  padding: 5px 12px;
  margin-right: 20px;
  border-radius: 6px;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;
  background: ${props => props.active ? "#EBECF0" : "#22292F"};
  color: ${props => props.active ? "#253858" : "#fff"};
  transition: 0.3s;
  border: 1px solid #fff;
  &:hover {
    opacity: 1;
    background: #000000;
    color: #fff;
  }
  &:focus {
    outline: 0px;
    background: #22292F;
    color: #fff;
  }
`;


const Menu = (props) => {
  const { isLogin } = props;
  const location = useLocation();
  // const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const userData = user?.user ?? null;
  
  function gotoApiDocumentation() {
    window.open('https://docs.ocaindonesia.co.id/oca-api/');
  }

  // function gotoHowToUse() {
  //   window.open('https://docs.ocaindonesia.co.id/oca-api/a-guide-to-use-oca-api/a-guide-to-use-oca-api');
  // }

  return (
    <Wrapper>
      <MenuWrapper>
        {/* <ButtonMenu
          active={location.pathname.indexOf("/dashboard") >= 0}
          onClick={() => history.push("/dashboard")}
        >
          Overview
        </ButtonMenu> */}
        {/* {isLogin && (
          <ButtonMenu
            active={location.pathname.indexOf("/my-application") >= 0}
            onClick={() => history.push("/my-application")}
          >
            My Application
          </ButtonMenu>
        )} */}
         {/* {isLogin && (
          <ButtonMenu
            active={location.pathname.indexOf("/generate-report") >= 0}
            onClick={() => history.push("/generate-report")}
          >
            Generate Report
          </ButtonMenu>
        )} */}
        <ButtonCustom
          active={location.pathname.indexOf("/docs") >= 0}
          onClick={() => gotoApiDocumentation()}
        >
          API Documentation
        </ButtonCustom>
        {/* <ButtonHelp
          active={location.pathname.indexOf("/help") >= 0}
          onClick={() => gotoHowToUse()}
          >
          <Img src={Svg.help.default}/>
        </ButtonHelp> */}
      </MenuWrapper>
      {isLogin ? (
        <ButtonUser user={userData} />
      ) : (
        <div>
          <Button className="margin-right-15" primary>
            Login
          </Button>
          <Button>Register</Button>
        </div>
      )}
    </Wrapper>
  );
};

Menu.propTypes = {
  isLogin: PropTypes.bool.isRequired,
};

export default Menu;
